import type {CourseApiModel} from '../../../api/course';
import type {GoalApiModel} from '../../../api/goal';
import type {ProgramApiModel} from '../../../api/program';
import type {MaybeExpanded} from '../../../api/types';

import {isMeCoachForEntity} from '../isMeCoachForEntity';

type Goal = GoalApiModel & {
  course: MaybeExpanded<CourseApiModel>;
  program: MaybeExpanded<ProgramApiModel>;
};

export const shouldGoalBeShown = (goal: Goal) => {
  const isMeGoalCoach = isMeCoachForEntity(goal);
  const isProgramDeleted = Boolean(goal.program?.deleted);
  const isCourseDeleted = Boolean(goal.course?.deleted);

  const shouldGoalBeIgnored =
    isMeGoalCoach && (isProgramDeleted || isCourseDeleted);

  return !shouldGoalBeIgnored;
};
